import MenuItemType from '@rootCommon/types/menu-item';
import { Dropdown } from '@rootCommon/components';
import MenuTrigger from './menu-trigger/MenuTrigger';
import MenuItem from './menu-item';
import './Menu.scss';

export type Props = {
  menuItems: MenuItemType[];
  username: string | null;
  avatarId?: number | null;
};

const Menu = ({ menuItems, username, avatarId }: Props): JSX.Element => (
  <Dropdown
    items={menuItems}
    trigger={<MenuTrigger {...{ username, avatarId }} />}
    classNameItem="user-auth__dropdown-item"
    renderItem={(item: MenuItemType) => <MenuItem item={item} />}
  />
);

export default Menu;
